import React, { useEffect, useState } from 'react';
import CookiePreferencesModal from './CookiePreferencesModal';

const CookieBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showPreferences, setShowPreferences] = useState(false);

  useEffect(() => {
    const displayBanner = localStorage.getItem('displayCookieBanner');
    if (displayBanner === null || displayBanner === 'true') {
      setIsVisible(true);
    }
  }, []);

  const acceptAll = () => {
    const preferences = {
      essential: true,
      analytics: true,
      marketing: true,
    };
    localStorage.setItem('cookiePreferences', JSON.stringify(preferences));
    localStorage.setItem('displayCookieBanner', 'false');
    setIsVisible(false);
  };

  const handleSavePreferences = (prefs: any) => {
    localStorage.setItem('cookiePreferences', JSON.stringify(prefs));
    localStorage.setItem('displayCookieBanner', 'false');
    setShowPreferences(false);
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <>
      <div style={styles.banner}>
        <span>
          We use cookies to improve your experience.{' '}
          <button style={styles.link} onClick={() => setShowPreferences(true)}>
            Manage Preferences
          </button>
        </span>
        <button style={styles.button} onClick={acceptAll}>
          Accept All
        </button>
      </div>

      {showPreferences && (
        <CookiePreferencesModal
          onClose={() => setShowPreferences(false)}
          onSave={handleSavePreferences}
        />
      )}
    </>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  banner: {
    position: 'fixed',
    bottom: 0,
    width: '100%',
    backgroundColor: '#222',
    color: '#fff',
    padding: '12px 24px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    zIndex: 1000,
    fontSize: '14px',
  },
  button: {
    backgroundColor: '#bef213',
    color: '#000',
    border: 'none',
    padding: '8px 16px',
    cursor: 'pointer',
    fontWeight: 'bold',
  },
  link: {
    color: '#bef213',
    background: 'none',
    border: 'none',
    textDecoration: 'underline',
    cursor: 'pointer',
    marginLeft: 8,
    fontSize: '14px',
  },
};

export default CookieBanner;
